import { useSelector } from "react-redux"
import styled from "styled-components"
import { setSelectUserData } from "../../features/user/userSlice"
import { showNestedModal } from "../../features/modal/modalSlice"
import { useDispatch } from "react-redux"
import avatar from "../../images/img/avatar.jpg"
import getPastDateAndTime from "../../helper/date/getPastDateAndTime"
import { useCallback, useState } from "react"
import { getAllUsersLocation, setFilteredUser, setFilteredUsersLocations, setHoveredMarker, updateFilterDuration, updateFilterDurationType, updateFilterPhoneNumber } from "../../features/locs/locsSlice"
import InputSearch from "../shared/input/locationView/InputSearch"
import InputFilterDate from "../shared/input/locationView/InputFilterDate"

const Container = styled.div`
    position: absolute;
    top: 60px;
    right: 0;
    width: 380px;
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: auto;
    background-color: ${({theme}) => theme.mainBgColor};

    .top-container{
        padding: 10px 15px;
        width: 100%;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        color: ${({theme}) => theme.mainTextColor};
        border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

        display: flex;
        flex-direction: column;
        gap: 15px;

        h4{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            margin-top: 10px;

        }

        .desc-text{
            font-size: 13px;
            font-weight: var(--font-weight-lg);
        }
        
    }

    .user-list{
        display: flex;
        flex-direction: column;
        width: 100%;
        cursor: pointer;

        .user-item{
            display: flex;
            align-items: flex-start;
            border-bottom: 1px solid var(--color-main);
            padding: 7px 0;

            .left-side {
                padding: 10px;

                img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid var(--color-main);
                }

            }

            .right-side {
                display: flex;
                flex-direction: column;
                gap: 5px;
                width: auto;
                padding: 5px;

                .username {
                font-size: 12px;
                font-weight: var(--font-weight-lg);
                }

                .phone-number {
                font-size: 12px;
                font-weight: var(--font-weight-lg);
                }

                .last-time{
                font-size: 12px;
                font-weight: var(--font-weight-lg);

                }

                .bottom-container{
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 20px;

                .version{
                    font-size: 12px;
                    font-weight: var(--font-weight-lg);

                }

                .button{
                    text-decoration: underline;
                    color: var(--color-main);
                    font-size: 12px;
                    font-weight: var(--font-weight-lg);
                }
                }

            }
        }
        

    }
`

function latLngToPoint(lat, lng, zoom) {
    const siny = Math.sin((lat * Math.PI) / 180);
    const clampedSiny = Math.min(Math.max(siny, -0.9999), 0.9999);
    const x = 256 * (0.5 + lng / 360);
    const y =
      256 *
      (0.5 - Math.log((1 + clampedSiny) / (1 - clampedSiny)) / (4 * Math.PI));
    const scale = Math.pow(2, zoom);
    return { x: x * scale, y: y * scale };
  }

const UserList = ({mapRef, mapContainerRef}) => {

    const {
        filteredUsersLocation,
        allUsersLocationList,
        filterDurationType,
        filterDurationHour,
        filterDurationDay,
        constantFilterDurationDay,
        constantFilterDurationHour,
        filterPhoneNumber,
        filteredUser
    } = useSelector(state => state.locs)

    const {
        selectedCity,
        selectedRegion
    } = useSelector(state => state.boundaries)

    const [typingTimeout, setTypingTimeout] = useState(null);

    const dispatch = useDispatch()

        const handleChange = (e) => {
            if(e?.target?.value?.length < 10){
                dispatch(updateFilterDuration({type: filterDurationType, data: e.target.value.replace(/[^0-9]/g, '')}))
                handleReq(e.target.value.replace(/[^0-9]/g, ''))
            }
        };
        
        const handleReq = (value) => {
            
            // Eğer daha önce bir timeout ayarlanmışsa iptal et
            if (typingTimeout) {
                clearTimeout(typingTimeout);
                }
            // Yeni bir timeout ayarla
            const timeout = setTimeout(() => {
                if(filterDurationType === 1 && parseInt(value) > 0){
                    dispatch(getAllUsersLocation({
                        duration: parseInt(value)
                    }))
                }
                else if (filterDurationType === 2 && parseInt(value) > 0){
                    dispatch(getAllUsersLocation({
                        duration: parseInt(value) * 24
                    }))
                }
            }, 1000); // 1 saniye (1000 ms)

            setTypingTimeout(timeout);
        }

  return (
    <Container>
        <div className="top-container">
            <h4>Sürücü Filtrele</h4>
            <InputSearch data={filterPhoneNumber} setData={(item) => dispatch(updateFilterPhoneNumber(item))} labelText={"Sücürü Ara"} inputWidth={"100%"} name={"searchUser"} initialOptions={allUsersLocationList}/>
            <InputFilterDate inputWidth={"100%"} data={filterDurationType === 1 ?  filterDurationHour : filterDurationDay} setData={(e) => handleChange(e)} labelText="Konum Son Güncelleme" name={"dateFilterUserLocs"} dateFilterType={filterDurationType} setDateFilterType={(data) => dispatch(updateFilterDurationType(data))}/>
            <p className="desc-text">{`Son ${filterDurationType === 1 ?  constantFilterDurationHour : constantFilterDurationDay} ${filterDurationType === 1 ? "Saat" : "Gün"} içerisinde konumu güncellenmiş sürücüler listelenmektedir.`}</p>
            <p className="desc-text">{allUsersLocationList.length +1}/{(selectedCity || selectedRegion || filteredUser) ? filteredUsersLocation.length : filteredUsersLocation.length+1} Üye</p>
            <p className="desc-text">! Üye konum tarihlerinde en eski tarih 1 Nisan 2024 tarihidir.</p>
        </div>
        <div className="user-list">
            {
                filteredUsersLocation.map(item => (
                    <div className="user-item" onClick={() => {dispatch(setFilteredUsersLocations({data: [item]})); dispatch(setFilteredUser(item)); dispatch(updateFilterPhoneNumber(item?.adSoyadUnvan))}}>
                        <div className="left-side">
                            <img
                                src={
                                    item.profilePhoto
                                    ? `${process.env.REACT_APP_API_IMG_URI}${item.profilePhoto}`
                                    : avatar
                                }
                                alt=""
                            />
                        </div>
                        <div className="right-side">
                            <div className="username">{item?.adSoyadUnvan}</div>
                            <div className="phone-number">{item?.phoneNumber}</div>
                            <div className="last-time">Son Konum Alma: {getPastDateAndTime(item.konumSonGorulme).formattedDate} {getPastDateAndTime(item.konumSonGorulme).formattedTime}</div>
                            <div className="bottom-container">
                                <div className="version">Sürüm: {item.appVersionNumber}</div>
                                <button className="button" onClick={(e) => {e.stopPropagation(); dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(item.phoneNumber))}}>Profili Görüntüle</button>
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    </Container>
  )
}

export default UserList